window.Branch = window.Branch || {};
window.Branch.product = window.Branch.product || {};

window.Branch.product.updateAppFeaturesSection = function(variant){
    let appFeaturesSections = document.querySelectorAll(".app-features");
    appFeaturesSections.forEach((appFeaturesSection) => {
        let allDefaultImages = appFeaturesSection.querySelectorAll(`.app-features__slide-media.app-features__slide-media--default`);
        let allDefaultSubtitles = appFeaturesSection.querySelectorAll(`.app-features__slide-subtitle.app-features__slide-subtitle--default`);

        allDefaultImages.forEach((defaultImage) => {
            defaultImage.style.display = "block"
          });
    
          allDefaultSubtitles.forEach((defaultSubtitle) => {
            defaultSubtitle.style.display = "block"
          })
    
    if(variant){
        let altVariantImages = appFeaturesSection.querySelectorAll(`.app-features__slide-media[data-variant-id="${variant.id}"]`);
        let allNonDefaultImages = appFeaturesSection.querySelectorAll(`.app-features__slide-media:not(.app-features__slide-media--default)`);
        
        let altVariantSubtitles = appFeaturesSection.querySelectorAll(`.app-features__slide-subtitle[data-variant-id="${variant.id}"]`);
        let allNonDefaultSubtitles = appFeaturesSection.querySelectorAll(`.app-features__slide-subtitle:not(.app-features__slide-subtitle--default)`);
        
  
     
        if(allNonDefaultImages.length > 0 ){
          allNonDefaultImages.forEach(( nonDefaultImage) => {
            nonDefaultImage.style.display = "none"
          })
        }
  
        if(allNonDefaultSubtitles.length > 0 ){
          allNonDefaultSubtitles.forEach(( nonDefaultSubtitle) => {
            nonDefaultSubtitle.style.display = "none"
          })
        }
        
        if(altVariantImages.length > 0){
          altVariantImages.forEach((altVariantImage) => {
            altVariantImage.parentElement.querySelectorAll('.app-features__slide-media').forEach((slideMedia) => {
              slideMedia.style.display = 'none';
            })
            altVariantImage.style.display = "block";
          })
        } 
  
        if(altVariantSubtitles.length > 0){
          altVariantSubtitles.forEach((altVariantSubtitle) => {
            altVariantSubtitle.parentElement.querySelectorAll('.app-features__slide-subtitle').forEach((slideSubtitle) => {
              slideSubtitle.style.display = 'none';
            })
            altVariantSubtitle.style.display = "block";
          })
        }
    }

    })
}         

$(function(){
    const initAppFeaturesSlider = function(event){
        if (typeof window.Swiper === 'undefined') {
            if (typeof window.whenSwiperReady === 'function') {
                window.whenSwiperReady(function(){ initAppFeaturesSlider(event); });
            }
            return;
        }
        let sliderContainers = document.querySelectorAll('.app-features__slider-container');

        sliderContainers.forEach((sliderContainer, index) => {
            let autoscroll = false;
            if(sliderContainer.getAttribute('data-enable-autoscroll') == "true"){
                let autoscrollInterval = parseInt(sliderContainer.getAttribute('data-autoscroll-interval')) * 1000;;
                autoscroll = {
                    delay: autoscrollInterval,
                    disableOnInteraction: true
                    }
            }

            let disableScrollAttr = sliderContainer.getAttribute('data-disable-scroll');
            let disableScroll = disableScrollAttr == "true";

            let params = {};
            if(event == "gallery-open"){
                params = {
                    slidesPerView: 1,
                    zoom: true,
                    spaceBetween: 0,
                    freeMode: false,
                    autoplay: autoscroll,
                    allowTouchMove: !disableScroll,
                    simulateTouch: !disableScroll,
                    allowSlideNext: !disableScroll,
                    allowSlidePrev: !disableScroll
                    }
            }
            if(event == "load"){
                let sliderElement = sliderContainer.querySelector('.app-features__slider');
                params = {
                    slidesPerView: 1.33333333333,
                    spaceBetween: 20,
                    freeMode: false,
                    autoplay: autoscroll,
                    allowTouchMove: true,
                    simulateTouch: true,
                    allowSlideNext: true,
                    allowSlidePrev: true,
                    navigation: {
                        nextEl: sliderContainer.querySelector('.app-features__right-arrow.swiper-button-next'),
                        prevEl: sliderContainer.querySelector('.app-features__left-arrow.swiper-button-prev'),
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 2.5,
                            spaceBetween: 40,
                            freeMode: false,
                            autoplay: autoscroll,
                            allowTouchMove: true,
                            simulateTouch: true,
                            allowSlideNext: true,
                            allowSlidePrev: true,
                            navigation: {
                                nextEl: sliderContainer.querySelector('.app-features__right-arrow.swiper-button-next'),
                                prevEl: sliderContainer.querySelector('.app-features__left-arrow.swiper-button-prev'),
                            }
                        },
                        1024: {
                            slidesPerView: 3.5,
                            spaceBetween: 40,
                            freeMode: false,
                            autoplay: autoscroll,
                            allowTouchMove: true,
                            simulateTouch: true,
                            allowSlideNext: true,
                            allowSlidePrev: true,
                            navigation: {
                                nextEl: sliderContainer.querySelector('.app-features__right-arrow.swiper-button-next'),
                                prevEl: sliderContainer.querySelector('.app-features__left-arrow.swiper-button-prev'),
                            }
                        },
                        1240: {
                            slidesPerView: 3.5,
                            spaceBetween: 40,
                            freeMode: false,
                            autoplay: autoscroll,
                            allowTouchMove: !disableScroll,
                            simulateTouch: !disableScroll,
                            allowSlideNext: !disableScroll,
                            allowSlidePrev: !disableScroll,
                            navigation: {
                                nextEl: sliderContainer.querySelector('.app-features__right-arrow.swiper-button-next'),
                                prevEl: sliderContainer.querySelector('.app-features__left-arrow.swiper-button-prev'),
                            }
                        }
                    },
                        on: {
                            init: function(){
                                if(this && this.slides[this.activeIndex] && this.slides[this.activeIndex].querySelector('video')){
                                    if(window.Branch.functions.isTouchDevice() == true){
                                        this.slides[this.activeIndex].querySelector('video').play();
                                    }
                                }
                            },
                            activeIndexChange: function () {
                                if(window.Branch.functions.isTouchDevice() == true){
                                    this.slides.forEach((slide) => {
                                        if(slide.querySelector('video')){
                                            slide.querySelector('video').pause();
                                        }
                                        console.log('slide.classList', slide.classList.contains('swiper-slide-active'))
                                        // if(slide.classList.contains('swiper-slide-active')){
                                        //     slide.querySelector('video').play();
                                        // }

                                    })
                                    if(this && this.slides[this.activeIndex] && this.slides[this.activeIndex].querySelector('video')){
                                        this.slides[this.activeIndex].querySelector('video').play();
                                    }
                                }
                            }
                    }
                }
                var appFeaturesSwiper = new Swiper(sliderElement, params);
            }
        })
    }


    const initHoverVideoPlay = function(video){
        video.addEventListener('mouseenter', function() {
            video.play();
        });
        video.addEventListener('mouseleave', function() {
            video.pause();
        });    
    }

    const initVideos = function(){
        let videos = document.querySelectorAll('.app-features__slider-container video');
        videos.forEach((video) => {
            function addLoadedClass() {
                video.setAttribute('data-video-loaded', true);
            }
    
            if (video.readyState >= 2) {
                addLoadedClass();
            } else {
                video.addEventListener('loadeddata', addLoadedClass);
            }


            if(window.Branch.functions.isTouchDevice() == false){
                initHoverVideoPlay(video);
            }
        });
        videos.forEach((video) => {
            video.load();
        })
    }
    
    const initAppFeatures = function(){
        initVideos();
        initAppFeaturesSlider("load");
    }
    
    window.addEventListener('load', function(){
        initAppFeatures();
    });
});